import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import africa from "../../../assets/images/africa.png";

const Commitment = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 0%" }} data-aos={"fade-up"}>
      <Box display={"flex"} justifyContent={"space-between"} flexWrap={"wrap"}>
        <Box
          width={{ xs: "100%", sm: "50%" }}
          paddingRight={{ xs: "0%", sm: "5%" }}
          paddingTop={{ xs: "0%", sm: "5%" }}
        >
          <Typography
            variant="h3"
            fontWeight={700}
            color={"#39484E"}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
          >
            Our Commitment
          </Typography>
          <Typography variant="body1" color={"#000"} textAlign={"left"}>
            AIR Fund is a catalyst for a future where resilience is not just an
            aspiration but a reality shared by empowered communities. By
            prioritizing locally driven solutions, leveraging advanced
            technologies, and addressing systemic inequities, AIR Fund seeks to
            redefine Africa’s development narrative, ensuring a legacy of
            self-sufficiency, innovation, and sustainable growth.
          </Typography>
          <Typography
            variant="h3"
            fontWeight={700}
            color={"#39484E"}
            padding={{ xs: "25% 0% 2% 0%", sm: "4% 0% 1% 0%" }}
            textAlign={"left"}
          >
            Our Theory of Change
          </Typography>
          <Typography variant="body1" color={"#000"} textAlign={"left"}>
            The African Innovation and Resilience Fund (AIR Fund) operates with
            the belief that investments in locally-driven, African-led
            innovation across the continent’s economic hubs will drive
            sustainable, scalable transformation. AIR Fund’s strategic
            investments in climate resilience, artificial intelligence,
            secondary city development, and innovation will boost African
            communities' access to tools and resources required to tackle
            pressing challenges and address evolving risks. The investments will
            achieve these aims through targeted grantmaking that identifies and
            scales up innovative approaches to improving economic development
            and accountability, while fostering public-private partnerships to
            enhance sustainability and buy-in. If these investments advance
            capacity-building, innovation, and strategic partnerships, then
            communities will be able to foster economic opportunity, build
            resilience, and create independent pathways to long-term growth.
            Therefore, AIR Fund seeks to catalyze a self-reinforcing cycle of
            innovation and resilience across Africa.
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "50%" }}
          display={{ xs: "none", sm: "block" }}
        >
          {" "}
          <Box
            component="img"
            height={{ xs: "47vh", sm: "750px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={africa}
            alt={"about_img"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Commitment;
